import axios from "axios";

import { apiBaseUrls } from "src/platform/constants/shared-constants";

export interface PlatformIdentityProvider {
  id: number;
  alias: string;
  displayName: string;
  providerType: string;
  issuer: string;
  metadataUrl: string | null;
  clientId: string;
  verifiedDomains: string[];
  status: string;
  validationStatus: string;
  validationError: string | null;
  generation: number;
  reconciliationStatus: string;
  reconciledGeneration: number | null;
  reconciledAt: string | null;
  reconciliationError: string | null;
  createdAt: string;
}

export interface CreatePlatformIdentityProviderInput {
  alias: string;
  displayName: string;
  issuer: string;
  metadataUrl: string;
  authorizationEndpoint: string;
  tokenEndpoint: string;
  jwksUri: string;
  clientId: string;
  clientSecretOpenBaoPath: string;
  verifiedDomains: string[];
}

function providerUrl(orgAlias: string): string {
  return `${apiBaseUrls.BACKEND}/api/v1/organizations/${encodeURIComponent(
    orgAlias,
  )}/platform-identity/providers`;
}

const requestOptions = { withCredentials: true };

export async function listPlatformIdentityProviders(
  orgAlias: string,
): Promise<PlatformIdentityProvider[]> {
  const response = await axios.get<PlatformIdentityProvider[]>(
    providerUrl(orgAlias),
    requestOptions,
  );
  return response.data;
}

export async function createPlatformIdentityProvider(
  orgAlias: string,
  input: CreatePlatformIdentityProviderInput,
): Promise<PlatformIdentityProvider> {
  const response = await axios.post<PlatformIdentityProvider>(
    providerUrl(orgAlias),
    input,
    requestOptions,
  );
  return response.data;
}

export async function validatePlatformIdentityProvider(
  orgAlias: string,
  providerId: number,
): Promise<PlatformIdentityProvider> {
  const response = await axios.post<PlatformIdentityProvider>(
    `${providerUrl(orgAlias)}/${providerId}/validate`,
    {},
    requestOptions,
  );
  return response.data;
}

export async function activatePlatformIdentityProvider(
  orgAlias: string,
  providerId: number,
): Promise<PlatformIdentityProvider> {
  const response = await axios.post<PlatformIdentityProvider>(
    `${providerUrl(orgAlias)}/${providerId}/activate`,
    {},
    requestOptions,
  );
  return response.data;
}

export async function disablePlatformIdentityProvider(
  orgAlias: string,
  providerId: number,
): Promise<PlatformIdentityProvider> {
  const response = await axios.delete<PlatformIdentityProvider>(
    `${providerUrl(orgAlias)}/${providerId}`,
    requestOptions,
  );
  return response.data;
}
